// color constants
const Common = {
  SMALL_SIGNATURE: "signature",
  SMALL_IMAGE: "image",
  ALL: "all",
  DELETED: "Deleted",
  PROJECT_MANAGEMENT_DASHBOARD: {
    TAB_ONE_LABEL: "Time & Effort Insights",
    TAB_TWO_LABEL: "Progress Overview",
    PROJECT_LABEL: "Project",
    PROJECT_PLACEHOLDER: "Select Project",
    FILTER_STRING_LABEL: "String",
    FILTER_LOCATION_LABEL: "Location",
    FILTER_SCOPE_LABEL: "Scope",
    FILTER_ASSET_LABEL: "No. of Asset per Location",
    RESET_FILTERS_BUTTON: "Reset Filters",
    RESET_ZOOM_BUTTON: "Reset Zoom",
    HOURS_WORKED_TITLE: "Hours Worked",
    LOCATION_SCOPE_SUBTITLE: "Location-wise hours grouped by scope",
    SELECT_PROJECT_MESSAGE: "Select a project to view chart data.",
    NO_DATA_MESSAGE: "No data available for the selected project.",
    ZERO_HOURS_MESSAGE: "No hours recorded for this project yet.",
    AVERAGE_REFERENCE_LABEL: "Average hours reference:",
    TOTAL_HOURS_LABEL: "Total hours logged:",
    AVERAGE_LINE_LABEL: "Average Hours",
    CHART_Y_AXIS_LABEL: "Hours Worked",
    TOOLTIP_LOCATION_PREFIX: "Location:",
    TOOLTIP_SCOPE_PREFIX: "Scope:",
    TOOLTIP_HOURS_PREFIX: "Hours:",
    NO_ASSETS_PLACEHOLDER: "No assets available",
    ASSET_COUNT_ERROR: "Failed to load asset count per location.",
    ASSET_COUNT_FALLBACK_MESSAGE: "Unable to fetch asset count per location.",
    ASSET_COUNT_PROJECT_REQUIRED: "Project id is required.",
  },
  PROJECT_EXCEL_UPLOAD: {
    FILE_EXTENSION: ".xlsx",
    INVALID_FILE: "Only .xlsx files are allowed.",
    NO_FILE_CHOSEN: "0 files chosen",
    ONE_FILE_CHOSEN: "1 file chosen",
    DOWNLOAD_ERRORS: "Download Errors",
    DOWNLOAD_TEMPLATE: "Download Template",
    TITLE: "Upload Project (Excel)",
    ACTION_UPLOAD: "Upload",
    FILE_LABEL: "Excel File (.xlsx)",
    FILE_HELPER:
      "Download the template, fill the required data in each sheet, then upload the same file.",
    CHOOSE_FILE: "Choose file",
    FILE_PLACEHOLDER:
      "Choose a multi-sheet Excel file with Locations, ProjectStrings, and Assets sheets.",
    FILE_PREVIEW_ALT: "Excel file preview",
    PREVIEW_ALT: "Preview",
    UPLOADING_PREFIX: "Uploading...",
    IMPORT_FAILED_TITLE: "We could not import this file yet.",
    UPLOAD_FAILED: "Upload failed",
    SELECT_PROJECT_REQUIRED: "Please select a project before uploading.",
    SELECT_FILE_REQUIRED: "Please choose an Excel file to upload.",
    SUCCESS_MESSAGE: "Project setup imported successfully.",
    RESELECT_AFTER_VALIDATION:
      "Update the file, then click Choose File and pick it again before retrying Upload.",
    RESELECT_AFTER_FAILURE: "Please click Choose File to select the file again before retrying.",
  },

  // File Constants
  IMAGE_JPEG: "image/jpeg",
  IMAGE_JPG: "image/jpg",
  IMAGE_PNG: "image/png",
  IMAGE_SVG: "image/svg+xml",
  PDF_FILE: "application/pdf",
  PDF: "pdf",
  FRAME: "Frame",
  UPDATE: "Update",
  NEW: "New",

  // Label Constants - Certificate
  CERTIFICATE_UPLOAD_LABEL: "Certificate (PDF, Image)*",
  CERTIFICATE_TYPE_LABEL: "Certificate Type*",
  CERTIFICATE_START_END_DATE_LABEL: "Certificate Start and End Date",
  USERS_LABEL: "Select User*",

  START_DATE_LABEL: "Start Date",
  END_DATE_LABEL: "End Date",
  DATE_FORMAT_MM_DD_YYYY: "mm/dd/yyyy",

  SERIAL_NUMBER: "serialNumber",
  UNIQUE: "unique",
  EQUIPMENT_TYPE: "equipmentType",
  WEIGHT_FORM: "weightForm",
  QUANTITY_TYPE: "quantityType",
  PRICE: "price",
  EQUIPMENT_CATEGORY: "equipmentCategory",
  HS_CODE: "hsCode",
  RENTAL: "rental",
  WEIGHT: "weight",
  WAREHOUSE: "warehouse",
  QUANTITY: "quantity",
  CONDITION: "condition",

  SELECT_PROJECT_STATUS_HINT_TEXT: "Select Project Status",
  SELECTED_PROJECT_STATUS_LIST: "projectStatusList",
  CLOSED_PROJECT_STATUS: "closed",

  // API Network Status Code
  API_STATUS_200: 200,
  API_STATUS_201: 201,
  API_STATUS_202: 202,
  API_STATUS_300: 300,
  API_STATUS_401: 401,
  API_STATUS_422: 422,
  API_STATUS_404: 404,
  API_STATUS_400: 400,
  API_STATUS_403: 403,
  API_STATUS_500: 500,

  // Regex
  NON_DIGIT_REGEX: /[^\d]/g,

  // Keyboard Keys Name
  ARROW_DOWN_KEY: "ArrowDown",
  ENTER_KEY: "Enter",

  // Start And End for Dates
  START: "start",
  START_DATE: "startDate",
  END: "end",
  END_DATE: "endDate",
  CURRENT_TIME_ZONE: Intl.DateTimeFormat().resolvedOptions().timeZone,
  DEFAULT_TIME_ZONE: "Europe/London",
  CURRENT_TIME_ZONE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  CURRENT_TIME_ZONE_T_FORMAT: "YYYY-MM-DD[T]HH:mm:ss",
  YEARS: "years",

  // Employment Type
  SELF_EMPLOYED: "self-employed",
  INTERNAL_EMPLOYEE: "employee",
  EXTERNAL_EMPLOYEE: "external/umbrella Company",

  INTERNAL_EMPLOYEE_API: "internal-employee",
  EXTERNAL_EMPLOYEE_API: "external-employee",

  // Setting page's card keys names
  ROLES_AND_PERMISSION: "roles-permission",
  PROJECT_STATUS: "project-status",

  // Role Management ==> Role create Modal
  ASSIGNED_PROJECT_LABEL: "Assign Projects",
  ASSIGNED_PROJECT_NAME: "isAssignAllProjects",
  ACCESS_TYPE_LABEL: "Access Type",
  ACCESS_TYPE_NAME: "accessType",

  OWN_KEY: "own",
  ALL_KEY: "all",
  BOTH_KEY: "both",

  // DPR
  COMPLETE_IN_SMALL_CASE: "complete",
  SAVE_IN_SMALL_CASE: "save",
  SELECT_CONDITION: "Select Condition",
  DPR_STATUS_OPEN: "open",
  DPR_STATUS_SUBMITTED: "submitted",
  DPR_STATUS_CLOSED: "closed",
  DPR_STATUS_REJECTED: "rejected",
  DPR_STATUS_APPROVED: "approved",
  DPR_STATUS_CANCELLED: "cancelled",
  DPR_STATUS_IN_PROGRESS: "in-progress",
  DPR_STATUS_COMPLETED: "completed",

  // Project Status Confirm Modal
  PROJECT_STATUS_CONFIRM_MODAL_TITLE_MESSAGE: "Are you sure you want to proceed ?",
  PROJECT_STATUS_CONFIRM_MODAL_BODY_MESSAGE:
    "You are currently only showing Closed projects, please change the settings to see the new submission.",
  // Label Constants - DPR
  CONTACT_ON_DPR: "Contact On DPR",
  SHOW_DETAILED_PROGRESS_LABEL: "Show Detailed Progress",
  SHOW_FULL_PROGRESS_SUMMARY: "Show full progress summary in DPR export",

  // Project Orders Request Screen Variables
  TEMPORARY_ITEMS_TYPE_TITLE_TEXT: "TMP",
  TEMPORARY_ITEMS_TYPES_TEXT: "temporaryItemsType",
  REQUESTED_ITEMS_TYPES_TEXT_KEY: "equipmentOrders",
  TEMPORARY_ITEMS_TYPES_TEXT_KEY: "tempOrders",
  PROJECT_TEXT: "project",
  EQUIPMENT_TEXT: "equipment",
  USER_TEXT: "user",

  PROJECT_ORDER_PROJECT_LABEL: "Project",
  PROJECT_ORDER_PROJECT_NAME: "project",
  PROJECT_ORDER_EQUIPMENT_TYPE_LABEL: "Equipment Type",
  PROJECT_ORDER_EQUIPMENT_TYPE_NAME: "equipmentType",
  PROJECT_ORDER_QUANTITY_LABEL: "Requested Qty",
  PROJECT_ORDER_QUANTITY_NAME: "engineerRequestedQuantity",
  PROJECT_ORDER_COMMENTS_LABEL: "Comments",
  PROJECT_ORDER_COMMENTS_NAME: "engineerComment",

  PROJECT_ORDER_TEMPORARY_PRODUCT_LABEL: "Equipment Name",
  PROJECT_ORDER_TEMPORARY_PRODUCT_NAME: "productName",
  PROJECT_ORDER_TEMPORARY_QUANTITY_LABEL: "Quantity",
  PROJECT_ORDER_TEMPORARY_QUANTITY_NAME: "engineerRequestedQuantity",

  // Project Order History Status
  PROJECT_ORDER_HISTORY_APPROVED_STATUS: "approved",
  PROJECT_ORDER_HISTORY_REJECTED_STATUS: "rejected",
  PROJECT_ORDER_HISTORY_CHECK_IN_STATUS: "check-in",
  PROJECT_ORDER_ADJUSTMENT_BLOCKED_STATUSES: [
    "in-transit",
    "partially-in-transit",
    "check-in",
    "partially-check-in",
    "check-out",
    "pre-check-out",
    "in-stock",
    "partially-in-stock",
    "missing",
    "rejected",
  ],

  // Project Order Shopping Cart Modal Form Variables
  PROJECT_ORDER_SHOPPING_CART_TITLE_LABEL: "Title*",
  PROJECT_ORDER_SHOPPING_CART_TITLE_NAME: "title",
  PROJECT_ORDER_SHOPPING_CART_PROJECT_LABEL: "Project Name*",
  PROJECT_ORDER_SHOPPING_CART_PROJECT_NAME: "project",
  PROJECT_ORDER_SHOPPING_CART_FROM_DATE_LABEL: "From Date*",
  PROJECT_ORDER_SHOPPING_CART_FROM_DATE_NAME: "fromDate",
  PROJECT_ORDER_SHOPPING_CART_TO_DATE_LABEL: "To Date*",
  PROJECT_ORDER_SHOPPING_CART_TO_DATE_NAME: "toDate",

  PROJECT_ORDER_SHOPPING_CART_EQUIPMENT_TYPE_LABEL: "Equipment",
  PROJECT_ORDER_SHOPPING_CART_EQUIPMENT_TYPE_NAME: "equipmentType",
  PROJECT_ORDER_SHOPPING_CART_QUANTITY_LABEL: "Quantity",
  PROJECT_ORDER_SHOPPING_CART_QUANTITY_NAME: "engineerRequestedQuantity",
  PROJECT_ORDDER_SHOPPING_CART_COMMENTS_LABEL: "Comments",
  PROJECT_ORDER_SHOPPING_CART_COMMENTS_NAME: "engineerComment",

  PROJECT_ORDER_QUEUE_SINGLE: "singleItemCart",

  // Inventory
  TEMP_CURRENCY: "TMP",

  // Status Constants
  Open: "Open",
  Closed: "Closed",
  Completed: "Completed",

  // Profile Fields
  RESOURCE_NUMBER: "Resource number",

  // QHSE Dates
  CUSTOM_RANGE: "Custom Range",
  CUSTOM_RANGE_ID: "custom range",
  CUSTOM_VALUE: "custom",

  // Profile(Personal Tab) Screen Labels
  USUAL_FIRST_NAME_LABEL: "Usual First Name",
  FIRST_NAME_LABEL: "First Name",
  LAST_NAME_LABEL: "Last Name",
  MAIN_LANGUAGE_LABEL: "Main Language",
  ADDRESS_LABEL: "Address",
  EMAIL_LABEL: "Email",
  ONBOARDING_STATUS_LABEL: "Onboarding Status",
  RESOURCE_NUMBER_LABEL: "Resource Number",
  COUNTRY_LABEL: "Country",
  CITY_LABEL: "City",
  STREET_LABEL: "Street/Building",
  AREA_LABEL: "Area",
  ZIP_CODE_LABEL: "Zip Code",
  STATE_LABEL: "State",
  NATIONALITY_LABEL: "Nationality",
  CONTACT_NUMBER_LABEL: "Contact Number",
  EMERGENCY_CONTACT_NUMBER_LABEL: "Emergency Contact Number",
  ROLE_NAME_LABEL: "Role Name",
  PROFILE_FUNCTION_LABEL: "Profile Function",
  AS_PER_PASSPORT_LABEL: "(As Per Passport)",
  PREF_AIRPORT_LABEL: "Preferred Airport Of Departure",
  OTHER_PREF_AIRPORT_LABEL: "Other Preferred Airport Of Departure",
  TRAVEL_TIME_TO_AIRPORT_LABEL: "Travel Time To Airport",
  SECOND_PREF_AIRPORT_LABEL: "Second Pref. Airport Of Departure",
  OTHER_SECOND_PREF_AIRPORT_LABEL: "Other Second Pref. Airport Of Departure",
  TRAVEL_TIME_TO_SECOND_AIRPORT_LABEL: "Travel Time To 2nd Airport",
  CLOTHES_SIZE_LABEL: "Clothes Size",
  SHOE_SIZE_LABEL: "Shoe Size",
  WINDA_ID_LABEL: "WINDA ID",
  CV_LABEL: "Curriculum Vitae (CV)",
  NEXT_OF_KIN_LABEL: "Next Of Kin",

  // Contractual Tab
  PASSPORT_ID_LABEL: "Passport/ID",
  PASSPORT_ID_DOCUMENT_LABEL: "Passport/ID Document",
  PASSPORT_ISSUE_DATE_LABEL: "Passport Issue Date",
  PASSPORT_EXPIRY_DATE_LABEL: "Passport Expiry Date",
  SECOND_PASSPORT_ID_LABEL: "Second Passport/ID",
  SECOND_PASSPORT_ID_DOCUMENT_LABEL: "Second Passport/ID Document",
  SECOND_PASSPORT_ISSUE_DATE_LABEL: "Second Passport Issue Date",
  SECOND_PASSPORT_EXPIRY_DATE_LABEL: "Second Passport Expiry Date",
  NATIONAL_ID_LABEL: "National Identification Number (BSN/NINO/SSN etc.)",
  DRIVERS_LICENSE_LABEL: "Driver's License",
  DRIVING_LICENSE_NUMBER_LABEL: "Driving License Number",
  DRIVING_LICENSE_DOCUMENT_LABEL: "Driving License Document",
  DRIVING_LICENSE_ISSUE_DATE_LABEL: "Driving License Issue Date",
  DRIVING_LICENSE_EXPIRY_DATE_LABEL: "Driving License Expiry Date",
  SEAMANS_BOOKLET_LABEL: "Seaman's Booklet",
  SEAMANS_BOOKLET_ISSUE_DATE_LABEL: "Seaman's Booklet Issue Date",
  SEAMANS_BOOKLET_EXPIRY_DATE_LABEL: "Seaman's Booklet Expiry Date",

  DATE_OF_BIRTH_LABEL: "Date Of Birth",
  PLACE_OF_BIRTH_LABEL: "Passport Holder's Place of Birth",
  EMPLOYMENT_TYPE_LABEL: "Employment Type",

  LIABILITY_INSURANCE_LABEL: "Liability Insurance Document",
  LIABILITY_INSURANCE_ID_LABEL: "Liability Insurance/ID",
  LIABILITY_INSURANCE_ISSUE_DATE_LABEL: "Liability Insurance Issue Date",
  LIABILITY_INSURANCE_EXPIRY_DATE_LABEL: "Liability Insurance Expiry Date",
  HEALTH_INSURANCE_LABEL: "Evacuation & Repatriation Insurance",
  HEALTH_INSURANCE_ID_LABEL: "Health Insurance/ID",
  HEALTH_INSURANCE_ISSUE_DATE_LABEL: "Health Insurance Issue Date",
  HEALTH_INSURANCE_EXPIRY_DATE_LABEL: "Health Insurance Expiry Date",

  COMPANY_NAME_LABEL: "Company Name",
  COMPANY_REGISTRATION_NR_LABEL: "Company Registration Nr.",
  COMPANY_REGISTRATION_DOCUMENT_LABEL: "Company Registration Document",
  COMPANY_VAT_NR_LABEL: "Company VAT Nr.",
  TAX_ID_NUMBERS_LABEL: "Tax Registration Numbers",
  COMPANY_ADDRESS_LABEL: "Company Address",
  COMPANY_EMAIL_LABEL: "Company Email",
  COMPANY_CITY_LABEL: "Company City",
  COMPANY_COUNTRY_LABEL: "Company Country",

  BANK_NAME_LABEL: "Bank Name",
  ACCOUNT_HOLDER_LABEL: "Account Name Holder",
  BANK_ACCOUNT_NR_LABEL: "Bank Account Nr (IBAN)",
  BANK_ACCOUNT_DOCUMENT_LABEL: "Bank Detail Proof",
  BIC_SWIFT_LABEL: "BIC/SWIFT",

  // QHSE General Constants
  DOCUMENT_NAME: "Document Name*",
  UPLOAD_DOCUMENT: "Upload Document*",
  UPDATE_DOCUMENT: "Update Document*",

  // Role Agreement
  PESONNEL_BASIC: "Personnel Basic",
  PERSONNEL: "Personnel",

  // Setup Report Constants
  ASSET_PER_LOCATION: "Asset per location",
  MULTIPLE_ASSETS: "Multiple assets",
  LOCATION: "Location",

  // Project Orders Constants
  REQUEST: "Requests",
  REJECTED: "Rejected",
  SHOPPING_CART: "Shopping Cart",
  ORDERS: "Orders",
  RETURN_ORDER: "Return Orders",

  // Permissions
  ORDER_APPROVAL: "Order Approval",
  PROJECT_ORDERS: "Project Orders",
  REQUEST_LABLE: "Request",
  PROJECT_EQUIPMENT_REQUEST: "Project Equipment Request",

  // Proejct Orders Comments
  MAKE_PM_COMMENT: "Make this PM Comment",

  // Key Values for API
  ASC_KEY: "asc",
  DESC_KEY: "desc",
  LOCATION_KEY: "location",
  LOCATION_INVENTORY: "Location",

  // Inventory list
  INVENTORY_SEARCH: "Equipment name or Category or type",
};

export default Common;
